import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import keycode from "keycode";
import { useEffect, useState } from "react";
import { body, getIsUk, globalContactCta, isNotUndefined, isNotUndefinedOrNull } from "../FunctionsCore";
import { LeadFormSharedComponent } from "../HandleLeadForm/HandleLeadForm";
import { addToRenderableData, renderIdentifierGeneric } from "../RenderIdentifier";
const infinityNumberClassName = "InfinityNumber";
const notEmptyString = (input) => typeof input === "string" && input.length > 0;
const emptyString = (input) => typeof input !== "string" || input.length === 0;
const handleChatPlaceHolderClick = () => {
    if (isNotUndefinedOrNull(window["truste"]) && isNotUndefinedOrNull(window["truste"].eu)) {
        window["truste"].eu.prefview();
    }
};
const FloatingContactOptionsComponent = (properties) => {
    const { floatingContactOptionsData, isUk, leadFormData, leadFormNotHidden, } = properties;
    const floatingContactOptionsDataAny = floatingContactOptionsData;
    const floatingContactOptionsDataFloatingContactOptionsData = floatingContactOptionsDataAny;
    const { configPropsUseExternalLeadform, cta_Leadform_Title, cta_Title_Mobile, ctaWithOrWithoutChatClass, external_leadform_page, externalLeadformPageExtensionRewritePath, href, pageProperties, phone_number_digits, phonenumber, disableChatOnPage } = floatingContactOptionsDataFloatingContactOptionsData;
    const { hide_leadform, phonenumberHide, suppress_leadform_button } = pageProperties;
    const externalLinkQueryStringParametersToUse = notEmptyString(pageProperties.external_link_query_string_parameters)
        ? pageProperties.external_link_query_string_parameters
        : floatingContactOptionsDataFloatingContactOptionsData.external_link_query_string_parameters;
    const externalLinkQueryStringParametersToUseTwo = typeof externalLinkQueryStringParametersToUse === "string" ? externalLinkQueryStringParametersToUse : "";
    const configPropertiesUseExternalLeadformIsEmpty = emptyString(configPropsUseExternalLeadform);
    const hideLeadformIsEmpty = emptyString(hide_leadform);
    const [chatLoaded, setChatLoaded] = useState(false);
    useEffect(() => {
        // Hacky fix for invalid HTML that is causing CTA elements to go inside div.content
        const openClassName = "open";
        const overlayClassName = "overlay";
        $(() => {
            const $body = $(body);
            const $contactCta = $(".contact_cta");
            const $document = $(window.document);
            const $footer = $("footer");
            const $pageFirst = $("#page").first();
            const $window = $(window);
            const $contactCtaCta = $contactCta.find(".cta");
            $contactCta.first().appendTo($pageFirst);
            $(".lead-form.ctabar").first().appendTo($pageFirst);
            if ($(".ctabar").length > 0 && $contactCtaCta.length > 0) {
                let contactBarHeight = 0;
                const measureFooter = () => {
                    // "true" includes top and bottom margins in the calculated height
                    const contactCtaCtaOuterHeight = $contactCtaCta.outerHeight(true);
                    if (isNotUndefined(contactCtaCtaOuterHeight)) {
                        contactBarHeight = contactCtaCtaOuterHeight;
                    }
                };
                const offsetContactBar = () => {
                    measureFooter();
                    // Also see integrated_search_panel.js
                    const extraSpace = 10;
                    $footer.css("margin-bottom", contactBarHeight + extraSpace);
                };
                globalContactCta.exists = () => true;
                globalContactCta.togglePanel = () => {
                    if ($contactCta.hasClass(openClassName)) {
                        $contactCta.removeClass(openClassName);
                        $body.removeClass(overlayClassName);
                    }
                    else {
                        $contactCta.addClass(openClassName);
                        $body.addClass(overlayClassName);
                    }
                };
                if ($contactCta.length > 0) {
                    $window.on("resize", () => {
                        // Offset footer for fixed contact bar
                        offsetContactBar();
                    });
                }
                $(".two-step-cta-close-button").on("click", () => {
                    globalContactCta.togglePanel();
                });
                $document.on("keydown", (eventObject) => {
                    // Escape key
                    if (eventObject.which === keycode.codes.esc && $contactCta.hasClass(openClassName)) {
                        globalContactCta.togglePanel();
                    }
                });
                offsetContactBar();
            }
            if (hideLeadformIsEmpty && configPropertiesUseExternalLeadformIsEmpty) {
                // Override default link behavior and toggle inline form
                $(".contact_cta .form .open-form-overlay").on("click", (cl) => {
                    cl.preventDefault();
                    cl.stopPropagation();
                    const $currentTarget = $(cl.currentTarget);
                    globalContactCta.togglePanel();
                    const ariaExpanded = $currentTarget.attr("aria-expanded");
                    let newAriaExpanded;
                    if (ariaExpanded === "true") {
                        newAriaExpanded = "false";
                    }
                    else {
                        newAriaExpanded = "true";
                        $(".lead-form .subtitle").trigger("focus");
                    }
                    $currentTarget.attr("aria-expanded", newAriaExpanded);
                });
            }
            if (isNotUndefinedOrNull(window["drift"])) {
                window["drift"].on("ready", () => {
                    setChatLoaded(true);
                });
            }
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "contact_cta" }, { children: _jsxs("section", Object.assign({ className: cx("cta", ctaWithOrWithoutChatClass, { ["placeholder"]: !disableChatOnPage && !chatLoaded }) }, { children: [emptyString(phonenumberHide) && notEmptyString(phone_number_digits) ? (_jsx("div", Object.assign({ className: cx("contact-method", "call") }, { children: _jsx("a", Object.assign({ className: cx(isUk ? infinityNumberClassName : void 0), "data-ict-silent-replacements": isUk ? "true" : void 0, href: href }, { children: _jsxs("div", Object.assign({ className: cx("text-container", "phone") }, { children: [_jsx("div", Object.assign({ className: cx("floatingContactOptionsPhoneNumber", isUk ? infinityNumberClassName : void 0) }, { children: phonenumber })), _jsx("div", { className: cx("floatingContactOptionsPhoneLogo", isUk ? infinityNumberClassName : void 0) })] })) })) }))) : (_jsx(_Fragment, {})), hideLeadformIsEmpty ? (_jsx("div", Object.assign({ className: cx("contact-method", "form") }, { children: configPropertiesUseExternalLeadformIsEmpty ? (_jsx("button", Object.assign({ "aria-label": "Button to open contact form", className: "open-form-overlay", type: "button" }, { children: _jsx("span", { className: emptyString(suppress_leadform_button) ? "new-form-image" : "new-form-image-hidden" }) }))) : (_jsx(_Fragment, { children: notEmptyString(external_leadform_page) ? (_jsxs("a", Object.assign({ className: cx("button", "v1", "ctaLeadFormLink"), href: externalLeadformPageExtensionRewritePath + externalLinkQueryStringParametersToUseTwo }, { children: [_jsx("div", { className: "icon" }), _jsx("span", Object.assign({ className: cx("text", "desktop") }, { children: cta_Leadform_Title })), _jsx("span", Object.assign({ className: cx("text", "mobile") }, { children: cta_Title_Mobile }))] }))) : (_jsx(_Fragment, {})) })) }))) : (_jsx(_Fragment, {})), !disableChatOnPage && !chatLoaded ? (_jsx("div", Object.assign({ className: cx("contact-method", "placeHolderChatWidget") }, { children: _jsx("button", Object.assign({ "aria-label": "Button to open chatcookie settings", className: "openChatCookieSettings", onClick: handleChatPlaceHolderClick, type: "button" }, { children: _jsx("span", { className: "new-chat-placeholder-image" }) })) }))) : (_jsx(_Fragment, {}))] })) })), leadFormNotHidden
                ? (_jsx("section", Object.assign({ className: cx("lead-form", "ctabar") }, { children: _jsxs("div", Object.assign({ className: "container" }, { children: [_jsx("button", { "aria-label": "Close", className: cx("two-step-cta-close-button"), type: "button" }), _jsx(LeadFormSharedComponent, { fromFloatingContactOptions: true, leadFormData: leadFormData })] })) })))
                : _jsx(_Fragment, {})] }));
};
const leadFormDataWrapper = {
    "leadFormData": void 0
};
const floatingContactOptions = (renderableData) => {
    // TODO For roiCalculator
    leadFormDataWrapper.leadFormData = renderableData.data.leadFormData;
    const isUk = getIsUk();
    renderIdentifierGeneric(FloatingContactOptionsComponent, addToRenderableData(renderableData, {
        "isUk": isUk,
    }));
};
export { floatingContactOptions, leadFormDataWrapper };
